import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import {
  Box,
  Collapse,
  List,
  ListItem,
  ListItemText,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import strings from "../../../global/constants/StringConstants";
import urls from "../../../global/constants/UrlConstants";
import { selectIsVedazUser } from "../../../redux/authSlice";
import { generateDashboardMenu } from "../../../utils/AuthorizationManager";
import history from "../../../utils/history";
import { useAppSelector } from "../../../utils/hooks";
import { theme } from "../../../utils/styles";
import ConsentFormDialog from "../Dialogs/ConsentFormDialog/ConsentFormDialog";
import appDrawerStyles from "./AppDrawer.styles";

const DashboardDrawer = () => {
  const classes = appDrawerStyles;
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const { t } = useTranslation();
  const [open, setOpen] = useState<any>({
    Category: false,
    "Sub Category": false,
  });
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(true);
  const [optionItems, setOptionItems] = useState<any[]>([]);
  const isVedazUser = useAppSelector(selectIsVedazUser);
  const [openConsentDialog, setOpenConsentDialog] = useState<boolean>(false);

  useEffect(() => {
    generateAppDrawer();
  }, []);

  const generateAppDrawer = () => {
    setOptionItems(generateDashboardMenu());
  };

  const isActiveTab = (pathName: string, key: string) => {
    const currentPath = window.location.pathname.toLowerCase();
    return (
      currentPath === pathName.toLowerCase() ||
      currentPath.includes(key.toLowerCase())
    );
  };

  const handleSubMenuClick = (pageName: string, event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen((prev: any) => ({
      ...prev,
      [pageName]: !prev[pageName],
    }));
  };

  const handleLinkClick = (option: any, event: React.MouseEvent) => {
    if (option.subMenu) return;
    event.preventDefault();

    if (option.pageName === strings.OTHER) {
      window.open(option.link, "_blank");
      return;
    }

    if (option.pageName === strings.VEDAZ_TALK) {
      if (isVedazUser) {
        history.push(urls.vedazTalkViewPath);
      } else {
        setOpenConsentDialog(true);
      }
      return;
    }
    history.push(option.key);
  };

  const getMenuOptions = (option: any, index: number) => {
    const isActive = isActiveTab(option.key, option.pageName);
    const Icon = option.icon;

    return (
      <Box key={index}>
        <Box
          onClick={(e) => handleLinkClick(option, e)}
          sx={[
            classes.dashboardMenuItem,
            isActive && classes.dashboardMenuActive,
            { cursor: "pointer" },
          ]}
        >
          <ListItem
            sx={{ p: 0 }}
            onClick={(e) =>
              option.subMenu ? handleSubMenuClick(option.pageName, e) : {}
            }
          >
            <Box sx={classes.dashboardMenuIcon}>
              {Icon && (
                <Icon sx={{ color: isActive ? "#FC72FF" : "#ffffff" }} />
              )}
            </Box>
            <ListItemText>
              <Typography
                sx={[
                  classes.dashboardMenuText,
                  isActive && classes.dashboardMenuActiveText,
                ]}
              >
                {t(option.text)}
              </Typography>
            </ListItemText>
            {option.subMenu && (
              <Box
                sx={{
                  ml: 1,
                  color: "#ffffff",
                  transition: "transform 0.3s ease",
                  transform: open[option.pageName]
                    ? "rotate(-90deg)"
                    : "rotate(0deg)",
                }}
              >
                {open[option.pageName] ? <ChevronLeft /> : <ChevronRight />}
              </Box>
            )}
          </ListItem>
        </Box>

        {option.subMenu && (
          <Collapse in={open[option.pageName]} sx={classes.dashboardSubmenu}>
            {option.subMenu.map((data: any, index: number) => {
              const isSubActive = isActiveTab(data.key, data.pageName);
              const SubIcon = data.icon;

              return (
                <Box
                  key={index}
                  onClick={(e) => handleLinkClick(data, e)}
                  sx={[
                    classes.dashboardSubmenuItem,
                    isSubActive && classes.dashboardMenuActive,
                    { cursor: "pointer" },
                  ]}
                >
                  <ListItem sx={{ p: 0 }}>
                    <Box sx={classes.dashboardMenuIcon}>
                      {SubIcon && (
                        <SubIcon
                          sx={{ color: isSubActive ? "#FC72FF" : "#ffffff" }}
                        />
                      )}
                    </Box>
                    <ListItemText>
                      <Typography
                        sx={[
                          classes.dashboardMenuText,
                          isSubActive && classes.dashboardMenuActiveText,
                        ]}
                      >
                        {t(data.text)}
                      </Typography>
                    </ListItemText>
                  </ListItem>
                </Box>
              );
            })}
          </Collapse>
        )}
      </Box>
    );
  };

  const getDashboardDrawer = () => {
    return (
      <List dense>
        {optionItems.map((option, index) => {
          return <Box>{getMenuOptions(option, index)}</Box>;
        })}
      </List>
    );
  };

  return (
    <>
      {getDashboardDrawer()}
      <ConsentFormDialog
        open={openConsentDialog}
        handleClose={() => setOpenConsentDialog(false)}
        setIsLoading={() => {}} // Add your loading handler here
      />
    </>
  );
};

export default DashboardDrawer;
